export default __webpack_public_path__ + "static/media/tier2.6204bd15.jpeg";